import Vue from 'vue';
import Router from 'vue-router';

import NotFound from './views/NotFound.vue';
import Home from './views/Home.vue';
import Reservate from './views/Reservate.vue';
import Tickets from './views/Tickets.vue';
import Welcome from './views/Welcome.vue';
import Verify from './views/Verify.vue';
import VisanetError from './views/VisanetError.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/inicio',
      name: 'Home',
      component: Home,
      redirect: { name: 'Welcome' },
    },
    {
      path: '/',
      name: 'Welcome',
      component: Welcome,
    },
    {
      path: '/reserva/:id?',
      name: 'Reservate',
      component: Reservate,
    },
    {
      path: '/entradas/:id',
      name: 'Tickets',
      component: Tickets,
      redirect: { name: 'Welcome' },
    },
    {
      path: '/verificar/:id?',
      name: 'Verify',
      component: Verify,
      redirect: { name: 'Welcome' },
    },
    {
      path: '/visanet-error',
      name: 'VisanetError',
      component: VisanetError,
    },
    {
      path: '*',
      component: NotFound,
    },
  ],
});

export default router;
